import { defaults } from 'typed/api';
import { combineReducers, entityAddReducer, entityDeleteReducer, entityEditReducer, entityLoadAllReducer, switchReducers } from './utils';

const acs = defaults.NetworkArrayOf(defaults.AnalysisCategory);

export default combineReducers({
    analysisCategories: switchReducers(acs,
        entityLoadAllReducer(acs, 'LOAD_ALL_ANALYSIS_CATEGORIES'),
        entityAddReducer(acs, 'ADD_ANALYSIS_CATEGORY'),
        entityEditReducer(acs, 'EDIT_ANALYSIS_CATEGORY'),
        entityDeleteReducer(acs, 'DELETE_ANALYSIS_CATEGORY')
    )
});
